import { createAction, props } from '@ngrx/store';
import { ITower } from 'app/models/tower';

export const clearAllItems = createAction('[DalHelper] Clear All Towers');
export const loadItems = createAction('[Inventory Towers List Page] Load Towers', props<{ barId: string; forceRefresh?: boolean }>());
export const loadItemsSuccess = createAction('[Tower API] Load Tower Success', props<{ items: ITower[] }>());
export const loadItemsFailure = createAction('[Tower API] Load Tower Failure', props<{ error: any }>());

export const updateItem = createAction('[Tower Detail Page] Update Tower', props<{ item: ITower }>());
export const updateItemSuccess = createAction('[Tower API] Update Towers Success', props<{ item: ITower }>());
export const updateItemFailure = createAction('[Tower API] Update Towers Failure', props<{ error: any }>());

export const addItem = createAction('[Tower Detail Page] Add Tower', props<{ id: string, item: ITower }>());
export const addItemSuccess = createAction('[Tower API] Add Towers Success', props<{ item: ITower }>());
export const addItemFailure = createAction('[Tower API] Add Towers Failure', props<{ error: any }>());

export const deleteItem = createAction('[Tower Detail Page] Delete Tower', props<{ id: string }>());
export const deleteItemSuccess = createAction('[Tower API] Delete Towers Success');
export const deleteItemFailure = createAction('[Tower API] Delete Towers Failure', props<{ error: any }>());

export const setItemAndNavigate = createAction('[Tower Detail Page] Set Selected Item And Navigate', props<{ id: string }>());
export const setItem = createAction('[Tower Detail Page] Set Selected Item', props<{ id: string }>());
export const setItemFromListPage = createAction('[Tower List Page] Set Selected Item', props<{ id: string }>());

export const softUpdate = createAction('[Tower API] Soft Update Tower', props<{ id: string, data: any, uid: string }>());
export const softUpdateSuccess = createAction('[Tower API] Soft Update Tower Success', props<{ id: string, data: any }>());
export const softUpdateFailure = createAction('[Tower API] Soft Update Tower Failure', props<{ error: any }>());
